// extracted by mini-css-extract-plugin
export default {"footerTop":"Footer_footerTop__cCkUy","content":"Footer_content__T2O6a","btn":"Footer_btn__4hu1W","credits":"Footer_credits__JMz2b"};